import React, { useContext } from "react";
import AddPolicial from "./components/AddPolicial";
import PolicialList from "./components/PolicialList";
import NavPage from "../../../components/NavPage";
import { BoletimContext } from "../../../context/BoletimContext";
import CabecalhoBoletim from "../../Boletim/components/CabecalhoBoletim";

function Efetivo() {
  const { boletim, setBoletim } = useContext(BoletimContext);

  return (
    <div className="bo-form-root">
      <CabecalhoBoletim texto="Adicionar Efetivo" />

      <AddPolicial boletim={boletim} setBoletim={setBoletim} />

      <PolicialList boletim={boletim} setBoletim={setBoletim} />

      <NavPage prev="../material" next="../historico" />
    </div>
  );
}

export default Efetivo;
